module.exports = Tesseract;


//////////////////
// WEBPACK FOOTER
// external "Tesseract"
// module id = 871
// module chunks = 